import React, { useContext } from 'react';
import { GradientTitleSection } from '@stereoagency/ui';
import { LinesContext } from '@/components/LinesContext';

type Props = {
  data: {
    title: string;
    headlinevariant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h1+' | 'h2+' | 'h3s'
  }
};

export default function NvisoGradientTitleSection({
  data: {
    title,
    headlinevariant
  },
}: Props) {
  const { enableLines } = useContext(LinesContext);

  return (
    <GradientTitleSection enableLines={enableLines} headlinevariant={headlinevariant}>
      {title}
    </GradientTitleSection>
  );
}
